export var RegistrationEvent;
(function (RegistrationEvent) {
    // Regular signup or login events
    RegistrationEvent["BUTTON_CLICK"] = "registrationBtnClick";
    RegistrationEvent["CONFIRMATION"] = "registrationConfirmation";
    RegistrationEvent["DOWNLOAD"] = "downloadButton";
    // PBE signup or login events
    RegistrationEvent["PBE_BUTTON_CLICK"] = "pbeRegistrationBtnClick";
    RegistrationEvent["PBE_CONFIRMATION"] = "pbeRegistrationConfirmation";
    RegistrationEvent["PBE_DOWNLOAD"] = "pbeDownloadButton";
})(RegistrationEvent || (RegistrationEvent = {}));
export var RSOPrompt;
(function (RSOPrompt) {
    RSOPrompt["LOGIN"] = "login";
    RSOPrompt["SIGNUP"] = "signup";
})(RSOPrompt || (RSOPrompt = {}));
//# sourceMappingURL=constants.js.map